import { render } from "./GoMatchBoard.vue?vue&type=template&id=409e45e6&scoped=true"
import script from "./GoMatchBoard.vue?vue&type=script&lang=js"
export * from "./GoMatchBoard.vue?vue&type=script&lang=js"

import "./GoMatchBoard.vue?vue&type=style&index=0&id=409e45e6&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409e45e6"]])

export default __exports__